
$(document).ready(()=>{
    let cstmopt1=document.querySelector('.opt--t1').classList;
    cstmopt1.forEach(variant_class_contains=>{
        if(variant_class_contains=='active'){
            $('.product_variant_size').html('Size |<span style="color:grey"> 12 Years</span>')
        }
    })
    let cstmopt2=document.querySelector('.opt--t2').classList;
    cstmopt2.forEach(variant_class_contains=>{
        if(variant_class_contains=='active'){
            $('.product_variant_size').html('Size |<span style="color:grey"> 14 Years</span>')
        }
    })
    let cstmopt3=document.querySelector('.opt--t3').classList;
    cstmopt3.forEach(variant_class_contains=>{
        if(variant_class_contains=='active'){
            $('.product_variant_size').html('Size |<span style="color:grey"> 16 Years</span>')
        }
    })
    let cstmopt4=document.querySelector('.opt--t4').classList;
    cstmopt4.forEach(variant_class_contains=>{
        if(variant_class_contains=='active'){
            $('.product_variant_size').html('Size |<span style="color:grey"> 18 Years</span>')
        }
    })                  
	$('.opt--t1').on('click',()=>{
    $('.product_variant_size').html('Size |<span style="color:grey"> 12 Years</span>');
    })
    $('.opt--t2').on('click',()=>{
        $('.product_variant_size').html('Size |<span style="color:grey"> 14 Years</span>');
    })
    $('.opt--t3').on('click',()=>{
        $('.product_variant_size').html('Size |<span style="color:grey"> 16 Years</span>');
    })
    $('.opt--t4').on('click',()=>{
        $('.product_variant_size').html('Size |<span style="color:grey"> 18 Years</span>');
    })
	
})
